import styled from "styled-components";

export const HeadH1 = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;

  & div {
    position: relative;
    left: 3px;
    font-style: normal;
    font-weight: 700;
    font-size: 1.125rem;
    line-height: 26px;
    text-align: center;
    letter-spacing: -0.02em;
    padding: 9px 0;
  }
  & img.img__left {
    height: 20px;
    width: 18px;
    cursor: pointer;
  }
  & img.img__right {
    height: 24px;
    width: 24px;
    cursor: pointer;
  }
`;
